import { provideZoneChangeDetection } from "@angular/core";
(window as any).CESIUM_BASE_URL = '/assets/Cesium/';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorInterceptor } from './app/core/services/error-interceptor.service';
import { appConfig } from './app/app.config';
import { apiInterceptor } from './app/core/interceptors/api.interceptor';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideZoneChangeDetection(),provideHttpClient(withInterceptors([apiInterceptor, ErrorInterceptor])),
    // ...other providers...
    ...(appConfig.providers || []),
  ],
}).catch((err) => console.error(err));
